import { useMutation } from '@tanstack/react-query';
import { postFranchiseReserve } from '../franchise.service';
import { FranchiseReserveRequest } from '../types/franchise.type';

export const useFranchiseReserve = () => {
  return useMutation({
    mutationFn: (body: FranchiseReserveRequest) => postFranchiseReserve(body),
  });
};
